import moment from 'moment';
const twoWeeksAgo = moment().subtract(14, 'days').format('YYYY-MM-DD');
const twoWeeksAgoEnd = moment().subtract(8, 'days').format('YYYY-MM-DD');
const weekAgo = moment().subtract(7, 'days').format('YYYY-MM-DD');
const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
export const requestData = [
    {
        key: 'free',
        transactions: {
            branches: [
                {
                    reasons: '18,19,29,30,9',
                    reasonsLabel: 'Free, LIS',
                },
            ],
            startDate: weekAgo,
            endDate: yesterday,
        },
    },
    {
        key: 'freeMathRewards',
        mathRewards: {
            branches: [
                {
                    label: 'Free spin rewards',
                    rewardType: 'spin',
                    extraDetails: {
                        spinTypeId: [0],
                    },
                },
                {
                    label: 'Free lootbox rewards',
                    creator: 'bought',
                    rewardType: 'lootbox',
                    extraDetails: {
                        lootboxId: [1],
                    },
                },
            ],
            startDate: weekAgo,
            endDate: yesterday,
        },
    },
    {
        key: 'freePreviousWeek',
        transactions: {
            branches: [
                {
                    reasons: '18,19,29,30,9',
                    reasonsLabel: 'Free, LIS',
                },
            ],
            startDate: twoWeeksAgo,
            endDate: twoWeeksAgoEnd,
        },
    },
    {
        key: 'freePreviousWeekMathRewards',
        mathRewards: {
            branches: [
                {
                    label: 'Free spin rewards',
                    rewardType: 'spin',
                    extraDetails: {
                        spinTypeId: [0],
                    },
                },
                {
                    label: 'Free lootbox rewards',
                    creator: 'bought',
                    rewardType: 'lootbox',
                    extraDetails: {
                        lootboxId: [1],
                    },
                },
            ],
            startDate: twoWeeksAgo,
            endDate: twoWeeksAgoEnd,
        },
    },
    {
        key: 'memberships',
        transactions: {
            branches: [
                {
                    reasons: '34,35,36',
                    reasonsLabel: 'Memberships',
                },
            ],
            startDate: weekAgo,
            endDate: yesterday,
        },
    },
    {
        key: 'membershipsPreviousWeek',
        transactions: {
            branches: [
                {
                    reasons: '34,35,36',
                    reasonsLabel: 'Memberships',
                },
            ],
            startDate: twoWeeksAgo,
            endDate: twoWeeksAgoEnd,
        },
    },
    {
        key: 'questsRewards',
        mathRewards: {
            branches: [
                {
                    label: 'Quests lootboxes, LIS',
                    creator: 'dailyQuest',
                    rewardType: 'lootbox',
                    extraDetails: {
                        lootboxId: [2, 3, 4],
                    },
                },
            ],
            startDate: weekAgo,
            endDate: yesterday,
        },
    },
    {
        key: 'questsRewardsPreviousWeek',
        mathRewards: {
            branches: [
                {
                    label: 'Quests lootboxes, LIS',
                    creator: 'dailyQuest',
                    rewardType: 'lootbox',
                    extraDetails: {
                        lootboxId: [2, 3, 4],
                    },
                },
            ],
            startDate: twoWeeksAgo,
            endDate: twoWeeksAgoEnd,
        },
    },
    {
        key: 'googlePlayMemberships',
        googlePlay: {
            branches: [
                {
                    productIds: ['status_buy3_gp', 'status_buy4_gp', 'status_buy5_gp'].join(),
                    label: 'Google Play Memberships',
                },
            ],
            convertToLis: true,
            startDate: weekAgo,
            endDate: yesterday,
        },
    },
    {
        key: 'googlePlayMembershipsPreviousWeek',
        googlePlay: {
            branches: [
                {
                    productIds: ['status_buy3_gp', 'status_buy4_gp', 'status_buy5_gp'].join(),
                    label: 'Google Play Memberships',
                },
            ],
            convertToLis: true,
            startDate: twoWeeksAgo,
            endDate: twoWeeksAgoEnd,
        },
    },
    {
        key: 'googlePlay',
        googlePlay: {
            branches: [
                {
                    productIds: ['soul_buy1_gp', 'soul_buy2_gp', 'soul_buy3_gp', 'soul_buy4_gp', 'soul_buy5_gp', 'soul_buy6_gp', 'offer_2x_income_gp', 'offer_additional_hangar1_gp', 'offer_additional_hangar2_gp', 'offer_auto_merge_gp', 'offer_starter_pack_gp', 'offer_last_chance_gp', 'offer_last_chance2_gp', 'offer_last_chance3_gp', 'offer_last_chance4_gp', 'offer_offline_earning_gp', 'offer_wall_street_card_gp', 'offer_weekly_tournament_gp', 'offer_xmas_special_gp', 'status_buy3_gp', 'status_buy4_gp', 'status_buy5_gp'].join(),
                    label: 'Google Play',
                },
            ],
            startDate: weekAgo,
            endDate: yesterday,
        },
    },
    {
        key: 'googlePlayPreviousWeek',
        googlePlay: {
            branches: [
                {
                    productIds: ['soul_buy1_gp', 'soul_buy2_gp', 'soul_buy3_gp', 'soul_buy4_gp', 'soul_buy5_gp', 'soul_buy6_gp', 'offer_2x_income_gp', 'offer_additional_hangar1_gp', 'offer_additional_hangar2_gp', 'offer_auto_merge_gp', 'offer_starter_pack_gp', 'offer_last_chance_gp', 'offer_last_chance2_gp', 'offer_last_chance3_gp', 'offer_last_chance4_gp', 'offer_offline_earning_gp', 'offer_wall_street_card_gp', 'offer_weekly_tournament_gp', 'offer_xmas_special_gp', 'status_buy3_gp', 'status_buy4_gp', 'status_buy5_gp'].join(),
                    label: 'Google Play',
                },
            ],
            startDate: twoWeeksAgo,
            endDate: twoWeeksAgoEnd,
        },
    },
    {
        key: 'googlePlayProducts',
        googlePlay: {
            branches: [
                {
                    productIds: ['soul_buy1_gp', 'soul_buy2_gp', 'soul_buy3_gp', 'soul_buy4_gp', 'soul_buy5_gp', 'soul_buy6_gp', 'offer_2x_income_gp', 'offer_additional_hangar1_gp', 'offer_additional_hangar2_gp', 'offer_auto_merge_gp', 'offer_starter_pack_gp', 'offer_last_chance_gp', 'offer_last_chance2_gp', 'offer_last_chance3_gp', 'offer_last_chance4_gp', 'offer_offline_earning_gp', 'offer_wall_street_card_gp', 'offer_weekly_tournament_gp', 'offer_xmas_special_gp'].join(),
                    label: 'Google Play',
                },
            ],
            convertToLis: true,
            startDate: weekAgo,
            endDate: yesterday,
        },
    },
    {
        key: 'googlePlayProductsPreviousWeek',
        googlePlay: {
            branches: [
                {
                    productIds: ['soul_buy1_gp', 'soul_buy2_gp', 'soul_buy3_gp', 'soul_buy4_gp', 'soul_buy5_gp', 'soul_buy6_gp', 'offer_2x_income_gp', 'offer_additional_hangar1_gp', 'offer_additional_hangar2_gp', 'offer_auto_merge_gp', 'offer_starter_pack_gp', 'offer_last_chance_gp', 'offer_last_chance2_gp', 'offer_last_chance3_gp', 'offer_last_chance4_gp', 'offer_offline_earning_gp', 'offer_wall_street_card_gp', 'offer_weekly_tournament_gp', 'offer_xmas_special_gp'].join(),
                    label: 'Google Play',
                },
            ],
            convertToLis: true,
            startDate: twoWeeksAgo,
            endDate: twoWeeksAgoEnd,
        },
    },
    {
        key: 'googlePlayMemberships',
        googlePlay: {
            branches: [
                {
                    productIds: ['status_buy3_gp', 'status_buy4_gp', 'status_buy5_gp'].join(),
                    label: 'Google Play',
                },
            ],
            convertToLis: true,
            startDate: weekAgo,
            endDate: yesterday,
        },
    },
    {
        key: 'googlePlayMembershipsPreviousWeek',
        googlePlay: {
            branches: [
                {
                    productIds: ['status_buy3_gp', 'status_buy4_gp', 'status_buy5_gp'].join(),
                    label: 'Google Play',
                },
            ],
            convertToLis: true,
            startDate: twoWeeksAgo,
            endDate: twoWeeksAgoEnd,
        },
    },
    {
        key: 'marketplace',
        transactions: {
            branches: [
                {
                    reasonsLabel: 'Marketplace volume',
                    reasons: 'itemPurchase',
                    currency: 'USDT',
                },
            ],
            startDate: weekAgo,
            endDate: yesterday,
        },
    },
    {
        key: 'marketplacePreviousWeek',
        transactions: {
            branches: [
                {
                    reasonsLabel: 'Marketplace volume',
                    reasons: 'itemPurchase',
                    currency: 'USDT',
                },
            ],
            startDate: twoWeeksAgo,
            endDate: twoWeeksAgoEnd,
        },
    },
    {
        key: 'marketplaceCount',
        transactions: {
            branches: [
                {
                    reasonsLabel: 'Marketplace volume',
                    reasons: 'itemPurchase',
                    currency: 'USDT',
                },
            ],
            sumCount: true,
            startDate: weekAgo,
            endDate: yesterday,
        },
    },
    {
        key: 'marketplaceCountPreviousWeek',
        transactions: {
            branches: [
                {
                    reasonsLabel: 'Marketplace volume',
                    reasons: 'itemPurchase',
                    currency: 'USDT',
                },
            ],
            sumCount: true,
            startDate: twoWeeksAgo,
            endDate: twoWeeksAgoEnd,
        },
    },
    {
        key: 'swapFees',
        swapFees: {
            baseCurrency: 'WLIS',
            startDate: weekAgo,
            endDate: yesterday,
        },
    },
    {
        key: 'swapFeesPreviousWeek',
        swapFees: {
            baseCurrency: 'WLIS',
            startDate: twoWeeksAgo,
            endDate: twoWeeksAgoEnd,
        },
    },
];
